<template>
  <div>
    <div>{{ alertTitle }}</div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    alertTitle: {
      type: String,
      default: "Alert"
    }
  }
};
</script>
